import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export default function Home() {
  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Content */}
      <div className="w-full lg:w-1/2 bg-white flex flex-col px-8 lg:px-16 py-12 pt-24">
        <div className="max-w-md mx-auto lg:mx-0">
          {/* Title */}
          <h1 className="text-3xl lg:text-4xl font-bold text-bronze mb-4">
            Portail d'Onboarding
          </h1>
          <h2 className="text-xl text-muted-foreground mb-8">
            Plateforme d'Intégration AIP
          </h2>

          {/* Description */}
          <p className="text-muted-foreground mb-8">
            Portail en libre-service pour l'intégration à la plateforme de Paiement Instantané.
            Soumettez vos identifiants et certificats pour commencer.
          </p>

          {/* Actions */}
          <div className="space-y-4">
            <Link to="/onboarding" className="block">
              <Button
                size="lg"
                className="w-full bg-gold hover:bg-gold/90 text-white font-semibold rounded-full"
              >
                Démarrer l'Onboarding
              </Button>
            </Link>
            <Link to="/lookup" className="block">
              <Button
                variant="outline"
                size="lg"
                className="w-full border-bronze text-bronze hover:bg-bronze hover:text-white rounded-full"
              >
                Rechercher ma Demande
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Right Panel - Decorative */}
      <div className="hidden lg:flex lg:w-1/2 bg-pattern-curves items-start justify-center p-12 pt-24">
        <div className="relative z-10 text-white max-w-lg">
          <h2 className="text-4xl font-bold mb-6">
            Plateforme d'Intégration
          </h2>

          {/* Feature cards */}
          <div className="space-y-4">
            <div className="bg-white/10 backdrop-blur rounded-lg p-4">
              <h3 className="font-semibold mb-1">1. Soumettre la Demande</h3>
              <p className="text-white/70 text-sm">
                Téléchargez vos certificats et identifiants via notre formulaire sécurisé.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur rounded-lg p-4">
              <h3 className="font-semibold mb-1">2. Revue & Approbation</h3>
              <p className="text-white/70 text-sm">
                Nos opérateurs examineront votre soumission et configureront votre environnement.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur rounded-lg p-4">
              <h3 className="font-semibold mb-1">3. Environnement Prêt</h3>
              <p className="text-white/70 text-sm">
                Recevez l'URL de votre environnement et commencez l'intégration.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
